import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

const hasValue = (a) =>
    Array.isArray(a)
        ? !!a.length
        : typeof a === "object"
        ? !!Object.keys(a).length
        : !!a;

const COMPARATORS = {
    "===": (a, b) => a === b,
    "!==": (a, b) => a !== b,
    includes: (a, b) => a && a.includes(b),
    hasValue: (a) => hasValue(a),
    hasNoValue: (a) => !hasValue(a),
};

export default function useDisplayCheck(fieldDisplay) {
    const [shouldDisplay, setShouldDisplay] = useState(
        typeof fieldDisplay === "boolean" ? fieldDisplay : true
    );

    const { control } = useFormContext();

    const watchers = useWatch({
        control,
        name: Array.isArray(fieldDisplay) ? fieldDisplay.map((a) => a[0]) : [],
    });

    useEffect(() => {
        if (watchers && watchers.length && Array.isArray(fieldDisplay)) {
            //  Logic for display
            let bool = true;
            fieldDisplay.forEach((cond, index) => {
                const [, com, p2] = cond;
                if (COMPARATORS[com]) {
                    bool = bool && COMPARATORS[com](watchers[index], p2);
                }
            });
            setShouldDisplay(bool);
        }
    }, [fieldDisplay, watchers]);

    return shouldDisplay;
}
